/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Home_Story_ImagesInputs */

const vi_shop_home_story_images = /** @type {(inputs: Shop_Home_Story_ImagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ảnh (tối đa ${i?.max})`)
};

/**

* @param {Shop_Home_Story_ImagesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_story_images = /** @type {((inputs: Shop_Home_Story_ImagesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Story_ImagesInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_story_images(inputs)
});